import { declineNumbered } from "./FormatUtils";

/**
 * Calculate the number of lightning icons to display based on risk level
 * @param risk - Risk level (0-100)
 * @returns Number of lightning icons to display (1-3)
 */
export function getNumberOfLightningIcon(risk: number): number {
  if (risk < 15) {
    return 1;
  }
  if (risk < 24) {
    return 2;
  }
  return 3;
}

/**
 * Format risk percentage text
 * @param risk - Risk level (0-1)
 * @returns Formatted risk text
 */
export function formatRiskText(risk?: number): string {
  return risk ? `Риск ${risk}%` : "Риск -";
}

/**
 * Format horizon text
 * @param horizon - Horizon in days
 * @returns Formatted horizon text
 */
export function formatHorizonText(horizon?: number): string {
  if (!horizon) {
    return "Горизонт -";
  }
  const yearPlural = declineNumbered(Math.round(horizon / 365), ["год", "года", "лет"]);
  return `Горизонт ${Math.round(horizon / 365)} ${yearPlural}`;
}

/**
 * Format profitability text
 * @param profitability - Profitability percentage
 * @returns Formatted profitability text
 */
export function formatProfitabilityText(profitability?: number): string {
  return profitability ? `+${profitability}% в год` : "- в год";
}
